import Api from "../config/Axios";

export const getOrderNotPartialList = (token, user_id, store_id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get("api/web/mart-health-dashboard-frontend-api-onp/"+store_id, config);
};


export const getMartHealthDashboardList = (token, user_id, store_id) => {
  const config = {headers: {Authorization: "Bearer " + (token ? token : ""), UserId: parseInt(user_id ? user_id : "")}};
  return Api.get(`api/web/mart-health-dashboard-frontend-api/`+store_id, config)
};